import {
  Bewerber,
  BewerberStatus,
  OFFBOARDING_STEPS,
  einstellenStepsFuer,
} from '../../types/bewerber';

/**
 * Der Stand der Checkliste, kompakt auf der Kanban-Kachel.
 *
 * Ohne ihn sah man einer Karte nicht an, wie weit sie ist — der Fortschritt
 * stand nur auf der Detailseite, und in „Bew. einstellen" entscheidet er
 * darüber, ob der Bewerber gleich weiterzieht. Gezeigt wird er genau dort, wo
 * die Liste auch bedienbar ist; anderswo wäre es eine Zahl ohne Handgriff.
 */
interface ChecklistBadgeProps {
  bewerber: Bewerber;
}

/** Welche Liste in diesem Status gilt — und ob überhaupt eine. */
function listeFuer(status: BewerberStatus) {
  switch (status) {
    case BewerberStatus.ONBOARDING:
    case BewerberStatus.GEWONNEN:
      return { steps: einstellenStepsFuer(status), name: 'Einstellen-Checkliste' };
    case BewerberStatus.OFFBOARDING:
      return { steps: OFFBOARDING_STEPS, name: 'Offboarding-Checkliste' };
    default:
      return null;
  }
}

export function ChecklistBadge({ bewerber }: ChecklistBadgeProps) {
  const liste = listeFuer(bewerber.status);
  if (!liste) return null;

  const total = liste.steps.length;
  const done = liste.steps.filter((step) => bewerber[step.field]).length;
  const complete = done === total;

  return (
    <span
      className={`inline-flex items-center gap-0.5 ${
        complete ? 'text-green-600' : 'text-gray-400'
      }`}
      title={`${liste.name}: ${done} von ${total} erledigt`}
    >
      <svg
        className="h-3.5 w-3.5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
      <span>
        {done}/{total}
      </span>
    </span>
  );
}

export default ChecklistBadge;
